import { componentVars } from '@infinex/ui-styles';
import { getDisplayMode, isIos26 } from '@infinex/ui-utils/dom';

/**
 * Returns true if running on iOS 26 Safari in "browser" display mode. Excludes
 * PWA/standalone mode where bottom chrome behaviour differs.
 */
export function isSafari26() {
  return isIos26() && getDisplayMode() === 'browser';
}

/** Bottom chrome height in Safari 26 browser mode (measured in pixels). */
export const IOS_26_BOTTOM_CHROME_HEIGHT = 98;

export const DIALOG_VIRTUAL_KEYBOARD_OFFSET_ID =
  'dialog-virtual-keyboard-offset';

/** Set by react-aria-components’ `ModalOverlay` component. */
export const RacOverlayVars = componentVars({
  pageHeight: '--page-height',
  viewportHeight: '--visual-viewport-height',
});

export const DialogVars = componentVars({
  // inherited from the dialog wrapper type
  maxHeight: '--Dialog-max-height',
  padding: '--Dialog-padding',
  // header-specific
  headerButton: '--Dialog-header-button',
  headerGap: '--Dialog-header-gap',
  headerGutter: '--Dialog-header-gutter',
  headerPaddingX: '--Dialog-header-padding-x',
  headerButtonSpacer: '--Dialog-header-button-spacer',
});

export const DialogRouterVars = componentVars({
  bodyHeight: '--DialogRouter-body-height',
  footerHeight: '--DialogRouter-footer-height',
  headerHeight: '--DialogRouter-header-height',
});

// Dialog Types ----------------------------------------------------------------

export const ModalVars = componentVars({
  maxHeight: '--Modal-max-height',
  maxWidth: '--Modal-max-width',
  padding: '--Modal-padding',
  viewportGutter: '--viewport-gutter',
});

export const POPOVER_INSET = 12;
export const PopoverVars = componentVars({
  inset: '--Popover-inset',
  maxHeight: '--Popover-max-height',
  maxWidth: '--Popover-max-width',
  padding: '--Popover-padding',
});

export const TRAY_INSET = 8;
export const TRAY_INSET_TOP = 56;
export const TrayVars = componentVars({
  inset: '--Tray-inset',
  insetBottom: '--Tray-inset-bottom',
  insetTop: '--Tray-inset-top',
  maxHeight: '--Tray-max-height',
  maxWidth: '--Tray-max-width',
  padding: '--Tray-padding',
});

export const SHEET_INSET = 16;
export const SheetVars = componentVars({
  detentHeight: '--Sheet-detent-height',
  insetBottom: '--Sheet-inset-bottom',
  insetTop: '--Sheet-inset-top',
  maxHeight: '--Sheet-max-height',
  padding: '--Sheet-padding',
});
